import React from "react";
import PropTypes from "prop-types";

import * as types from "../../../constants/ComponentConstants";

import Form from "../../common/Form";
import Section from "../../common/Section";
import TextAreaInput from "../../common/TextAreaInput";
import Row from "../../common/Row";
import Fieldset from "../../common/Fieldset";

const AndereOpmerkingForm = (props) => {
    const {
        model,
        onChange,
        onSave,
        errors,
        validationMessageType,
        disabled,
        andereOpmerkingHasFocus
    } = props;

    return (
        <Section title="Andere opmerkingen" color={types.COLOR_ORANGE}>
            <Form name="Andere opmerking"
                headerVisible={false}
                isNotRequired
                rightButtonLabel="Bewaar"
                onRightButtonClick={onSave}
                rightButtonDisabled={disabled}
            >
                <Fieldset>
                    <Row>
                        <TextAreaInput
                            name="opmerking"
                            label="Andere opmerkingen"
                            value={model.opmerking}
                            onChange={onChange}
                            disabled={disabled}
                            validationMessage={errors ? errors['opmerking'] : ""}
                            validationMessageType={validationMessageType}
                            size={12}
                            optional
                            hasFocus={andereOpmerkingHasFocus}
                        />
                    </Row>
                </Fieldset>
            </Form>
        </Section>
    );
};

AndereOpmerkingForm.propTypes = {
    model: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    errors: PropTypes.object,
    validationMessageType: PropTypes.string,
    disabled: PropTypes.bool,
    andereOpmerkingHasFocus: PropTypes.bool
};

export default AndereOpmerkingForm;